import {
    DATA_SHIP_DEMOLITION_LIST_GET,
    DATA_SHIP_DEMOLITION_LIST_GET_F,
    DATA_SHIP_DEMOLITION_LIST_GET_R,
    DATA_SHIP_DEMOLITION_SELECTED_SET,
  } from '../actionType'
  
  export const datashipDemolitionListGetAction = (params : any) => ({
    type: DATA_SHIP_DEMOLITION_LIST_GET,
    payload: params
  })
  
  export const datashipDemolitionListGetFAction = (data : any) => ({
    type: DATA_SHIP_DEMOLITION_LIST_GET_F,
    payload: data
  })
  
  export const datashipDemolitionListGetRAction = ( error : any) => ({
    type: DATA_SHIP_DEMOLITION_LIST_GET_R,
    payload: error
  })
  
  export const datashipDemolitionSetSelectedAction = (demolition : any) => ({
    type: DATA_SHIP_DEMOLITION_SELECTED_SET,
    payload: demolition
  })